<template>
  <div>
    <el-row align="middle" class="sign-content" justify="center" type="flex">
      <el-col span="24">
        <el-form :model="form" ref="form">
          <el-form-item label="新手机号">
            <el-input placeholder="输入新手机号" v-model="form.mobile">
              <span @click="getValidCode" class="sign-verify_code" slot="suffix" v-show="authcodeStatus === 0">{{ countDown > 0 ? countDown : '获取验证码' }}</span>
              <i class="el-icon-loading" slot="suffix" v-show="authcodeStatus === 1"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="短信验证码">
            <el-input placeholder="输入收到的短信验证码" v-model="form.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :disabled="disableButton" @click="onSubmit" style="width: 100%;" type="primary">修改</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc1 } from '../../../service/index';
import { M } from '../../../service/grpc';
import { getToken } from '../../../service/helper';
import { setTimeout, clearTimeout } from 'timers';

export default {
  data() {
    return {
      token: getToken(),
      form: {
        mobile: '',
        code: ''
      },
      authcodeStatus: 0, // 0 正常状态  1 正在请求发送验证码
      countDown: 0
    };
  },
  computed: {
    disableButton() {
      const { code, mobile } = this.form;
      return !code || !mobile;
    }
  },
  methods: {
    stopCountDown() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    startCountDown() {
      if (this.countDown === 0) return this.stopCountDown();

      this.countDown = this.countDown - 1;
      this.timer = setTimeout(this.startCountDown, 1000);
    },
    validMobile() {
      return true
      return this.form.mobile.length === 11;
    },
    validAuthCode() {
      return /^\d{4}$/.test(this.form.code);
    },
    errorMessage(message) {
      this.$message({ message, type: 'error' });
    },
    onSubmit() {
      if (!this.validMobile()) return this.errorMessage('请输入正确的手机号码');
      if (!this.validAuthCode()) return this.errorMessage('请输入正确的验证码');

      rpc1(
        'StoreAuthService.UpdateMobile',
        M('UpdateMobileRequest', {
          token: M('Token', { token: this.token }),
          codetoken: M('Token', { token: this.codetoken }),
          mobile: this.form.mobile,
          code: this.form.code
        })
      ).then(res => {
        this.$emit('success');
      });
    },
    getValidCode() {
      if (!this.validMobile()) return this.errorMessage('请输入正确的手机号码');

      this.authcodeStatus = 1;
      rpc1(
        'StoreAuthService.UpdateMobileSendCode',
        M('WithTokenCodeRequest', {
          token: M('Token', { token: this.token }),
          mobile: this.form.mobile
        })
      )
        .then(res => {
          this.codetoken = res.token;
          this.countDown = 60;
          this.startCountDown();
          this.authcodeStatus = 0;
        })
        .catch(e => {
          this.authcodeStatus = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-content {
  background-color: white;
}
.el-input--suffix .el-input__inner {
  padding-right: 90px;
}
.sign-verify_code {
  padding-right: 5px;
  font-size: 12px;
  cursor: pointer;
  color: #888;
}
</style>
